import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var FailedIKError = /*#__PURE__*/function (_Error) {
  _inherits(FailedIKError, _Error);

  var _super = _createSuper(FailedIKError);

  function FailedIKError(initialMsg, message) {
    var _this;

    _classCallCheck(this, FailedIKError);

    _this = _super.call(this, message);

    _defineProperty(_assertThisInitialized(_this), "initialMsg", void 0);

    _this.initialMsg = initialMsg;
    _this.name = "FailedIKhandshake";
    return _this;
  }

  return FailedIKError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
;